import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./CreateGroupModal.css";

const InsertRangeModal = ({
  show,
  handleClose,
  handleNamedDraftRelation,
  setDestination,
  setSource,
  source,
  destination,
}) => {
  // const [source, setSource] = useState("");
  // const [destination, setDestination] = useState("");

  // Option 1: Using useEffect
  useEffect(() => {
    if (show) {
      setSource("");
      setDestination("");
    }
  }, [show]);

  // Option 2: Modify the handleClose to also reset values
  const handleModalClose = () => {
    setSource("");
    setDestination("");
    handleClose();
  };

  const handleSubmit = () => {
    handleNamedDraftRelation(source, destination);
    handleModalClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose} className="attach-files-modal">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>Insert Range</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="form-group">
            <label htmlFor="childName" className="form-label fw-500">
              From<span className="text-danger"> *</span>
            </label>
            <input
              type="text"
              id="source"
              className="form-control"
              placeholder="Source"
              value={source}
              onChange={(e) => setSource(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="childName" className="form-label fw-500">
              To<span className="text-danger"> *</span>
            </label>
            <input
              type="text"
              id="destination"
              className="form-control"
              placeholder="Destination"
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          className="create-button"
          onClick={handleSubmit}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InsertRangeModal;
